import { render } from "./DiabetesReviewModal.vue?vue&type=template&id=2fa92b86&scoped=true"
import script from "./DiabetesReviewModal.vue?vue&type=script&lang=js"
export * from "./DiabetesReviewModal.vue?vue&type=script&lang=js"

import "./DiabetesReviewModal.vue?vue&type=style&index=0&id=2fa92b86&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa92b86"]])

export default __exports__